export const CREATE_OPERATIONAL_PLAN_PAYLOAD = {
  title: 'Schema for loading planner data',
  type: 'object',
  properties: {
    planStartWeek: { type: 'string', format: 'date' },
    templateStartDateKey: { type: 'string', format: 'date' },
    planDescription: { type: 'string' },
    planHorizon: { type: 'integer' },
    constrainingHorizon: { type: 'integer' },
    sourceSites: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          siteKey: { type: 'string' },
          siteCode: { type: 'string' },
          siteLabel: { type: 'string' },
          siteWorkcentres: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                code: { type: 'string' },
                isSelected: { type: 'boolean' },
                key: { type: 'string' },
                productCount: { type: 'integer' },
              },
              required: ['code', 'isSelected', 'key', 'productCount'],
            },
          },
        },
        required: ['siteKey', 'siteCode', 'siteLabel', 'siteWorkcentres'],
      },
    },
    planAccessType: { type: 'string', enum: ['public', 'private'] },
    planType: { type: 'string', enum: ['scenario'] },
    projectId: { type: 'string' },
    scenarioId: { type: 'string' },
    extractData: { type: 'boolean' },
    unconstrainedPlan: { type: 'boolean' },
  },
  required: [
    'planStartWeek',
    'planDescription',
    'planHorizon',
    'constrainingHorizon',
    'sourceSites',
    'extractData',
    'unconstrainedPlan',
    'planAccessType',
  ],
  dependentRequired: {
    projectId: ['planType'],
    scenarioId: ['planType'],
    templateStartDateKey: ['planType'],
  },
}
